// Tag Util
import _ from 'lodash'

import app from '../app.jsx'

class TagUtil {
  getProjectTags (callback) {
    this._getTagsByType('project', callback)
  }

  getSkillTags (callback) {
    this._getTagsByType('skill', callback)
  }

  /* Private functions */
  _getTagsByType (type, callback) {
    const params = {
      query: {
        objectType: type
      }
    }

    app
      .service('/api/tag')
      .find(params)
      .then(res => {
        const tagsData = _.uniqBy(res.data, tagObj => tagObj.title)
        const tags = tagsData.map((tagObj, _idx) => tagObj.title)
        callback(tags)
      })
      .catch(err => {
        app.debug('TagUtil: _getTagsByType ERROR', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }
}

export default new TagUtil()
